export default __webpack_public_path__ + "d9707914bf6f3a64ec962448ccc67f3d.svg";